// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__Dlmgu","row":"style_row__195i_","title":"style_title__1xqGe","outlined":"style_outlined__eYeEo"};